const SIZES = ['xsmall', 'small', 'medium', 'large'];
const TYPES = ['default', 'primary', 'light'];

const kovButtonOnClick = 'onClick';

class KovButton {
  constructor($scope) {
    'ngInject';

    this.$scope = $scope;
  }

  $onInit() {
    this.sSize = this.sSize && SIZES.find(s => s === this.sSize) || 'medium';
    this.sType = this.sType && TYPES.find(t => t === this.sType) || 'default';
    this.sDisabled = this.sDisabled || false;
  }

  getStyleClass() {
    let styles = [];

    let type = 'kb-' + this.sType;
    styles.push(type);

    let size = 'kb-' + this.sSize;
    styles.push(size);

    return styles.join(' ');
  }

  onClick() {
    this.$scope.$emit(kovButtonOnClick, this.sId);
  }
}

module.exports = {
  template: require('./kovButton.html'),
  controllerAs: 'ctrl',
  controller: KovButton,
  transclude: true,
  bindings: {
    sId: '@?',
    sType: '@',
    sSize: '@',
    sDisabled: '<',
    sLoading: '<',
    sLoadingText: '<',
    sTooltip: '@'
  }
};
